import { get, post, put, del } from '../utils/httpInterceptor';
import { getCompanyId } from '../utils/companyHelper';
import { buildCrudQueryParams } from './filterQueryBuilder';

class PeopleService {
  static async getAll(page, size, filters = {}, sortConfig = {}) {
    const queryParams = buildCrudQueryParams({
      page,
      size,
      filters,
      sortConfig,
      sortMode: 'split',
    });

    return await get(`/people?${queryParams.toString()}`);
  }

  static async getById(personId) {
    return await get(`/people/${personId}`);
  }

  static async create(payload) {
    const companyId = getCompanyId();
    return await post('/people', { ...payload, companyId });
  }

  static async update(personId, payload) {
    const companyId = getCompanyId();
    return await put(`/people/${personId}`, { ...payload, companyId });
  }

  static async delete(personId) {
    return await del(`/people/${personId}`);
  }

  static async updateEnabled(personId, payload) {
    const companyId = getCompanyId();
    return await put(`/people/enabled/${personId}`, { ...payload, companyId });
  }

  static async updateUserEnabled(personId, payload) {
    const companyId = getCompanyId();
    return await put(`/people/user-enabled/${personId}`, { ...payload, companyId });
  }

  static async resetUserPassword(personId) {
    return await put(`/people/user-password-reset/${personId}`, {});
  }
}

export default PeopleService;

